import React, { useCallback, useEffect, useRef } from "react";
import javascriptHandler from "../apis/javascriptHandler";
import useLongPress from "../hooks/useLongPress";
import { withVersionParams } from "../HOC/withVersionParams";
import OnboardAgrContent10601 from "../components/OnboardAgrPage/OnboardAgrContent10601";
import OnboardAgrContent10602 from "../components/OnboardAgrPage/OnboardAgrContent10602";

interface Props {
   v: number;
}

const OnboardAgrPage: React.FC = () => {
   const v = 10601;
   const btnRef = useRef<HTMLButtonElement>(null);
   const [isIssuing, setIsIssuing] = React.useState<boolean>(false);
   const [checked, setChecked] = React.useState(false);
   // const classes = useStyles();

   const _domain = process.env.REACT_APP_BASE_URL;

   const goTo = useCallback(
      (e: React.MouseEvent<HTMLElement>, link: string) => {
         e.preventDefault();
         // javascriptHandlers.openWebView(link);
         javascriptHandler._callHandler("OpenWebView", _domain + link);
      },
      []
   );

   const onClick = useCallback(async () => {
      if (isIssuing) return;
      setIsIssuing(true);
      javascriptHandler._callHandler("_onBtnClick", "1");
      setIsIssuing(false);
   }, [isIssuing]);

   // const longPress = useLongPress({
   //    onClick: () => {
   //       javascriptHandler._callHandler("_onBtnClick", "1");
   //    },
   //    onLongPress: () => {
   //       javascriptHandler._callHandler("_onBtnLongClick", "1");
   //    },
   //    ms: 300,
   // });

   // useEffect(() => {
   //    if (!isIssuing && checked) {
   //       btnRef.current?.addEventListener("touchstart", longPress.onTouchStart);
   //       btnRef.current?.addEventListener("touchend", longPress.onTouchEnd);
   //    }
   //    return () => {
   //       btnRef.current?.removeEventListener(
   //          "touchstart",
   //          longPress.onTouchStart
   //       );
   //       btnRef.current?.removeEventListener("touchend", longPress.onTouchEnd);
   //    };
   // }, [isIssuing, checked]);

   return (
      <>
         {v <= 10601 ? (
            <OnboardAgrContent10601
               checked={checked}
               setChecked={setChecked}
               goTo={goTo}
               btnRef={btnRef}
               onClick={onClick}
            />
         ) : (
            <OnboardAgrContent10602
               checked={checked}
               setChecked={setChecked}
               goTo={goTo}
               btnRef={btnRef}
               onClick={onClick}
            />
         )}
      </>
   );
};

export default withVersionParams(OnboardAgrPage);
